import { TipoAtendimentoEnum } from "../enums/tipo-atendimento.enum";

export class MesaRequest {
    constructor(
        public numeroMesa: number,
        public grupo: TipoAtendimentoEnum
    ) { }
}
